import {useContext} from 'react';
import {mixpanelContext} from './MixpanelContext';

export const useMixpanel = () => {
  const {mixpanel} = useContext(mixpanelContext);

  return {mixpanel};
};
